<tnq-dialog [dialogTitle]="data.title">
  <p
    class="info-dialog__body"
    [innerHTML]="data.message | translate | safeHtml"
  ></p>
  <sui-button
    dialog-footer
    color="brand"
    variant="ghost"
    radius="full"
    (click)="close()"
  >
    {{ data.closeLabel ?? 'global.close' | translate }}
  </sui-button>
</tnq-dialog>
